import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import PageGray from '@/components/General/PageGray';
import H1 from '@/components/Typography/Headings/H1';
import Loader from '@/components/Loader/Loader';
import { useRGPage } from '@/hooks/useRGPage';
import RGSectionList from '@/components/RGSection/RGSectionList';
import { Chip } from '@testbusters/chip';

export const Route = createFileRoute('/_sidebar/risorse-gratuite')({
  component: RouteComponent,
});

const RG_PAGE_ITA = import.meta.env.VITE_RG_PAGE_ITA as string;
const RG_PAGE_ENG = import.meta.env.VITE_RG_PAGE_ENG as string;

function RouteComponent() {
  const { t, i18n } = useTranslation();
  const pageId = i18n.language.startsWith('en') ? RG_PAGE_ENG : RG_PAGE_ITA;
  const { sections, anchors, isFetching } = useRGPage(pageId);

  if (isFetching) return <Loader fullScreen />;

  return (
    <PageGray className="flex flex-col gap-9">
      <div className="flex flex-col gap-4">
        <H1>{t('nav.risorseGratuite')}</H1>
      </div>
      <div className="flex gap-4 items-center">
        {anchors.map((anchor) => (
          <a
            key={anchor.id}
            href={`#${anchor.id}`}
            className="w-fit cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById(anchor.id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
          >
            <Chip className='bg-white border border-button-primary-primary-default font-normal! text-sm!'>{anchor.label}</Chip>
          </a>
        ))}
      </div>
      <RGSectionList sections={sections} />
    </PageGray>
  );
}
